import Award, { type AwardCardProps } from "./award-card";

import { Money } from "@quint/components";
import { formatBigNumber } from "@quint/services/web3";
import {
  luxuryPoolAAddress,
  useLuxuryPoolAGetUserInfo,
  useLuxuryPoolAWithdraw,
  usePrepareLuxuryPoolAWithdraw,
} from "@quint/services/web3/hooks/luxury-pool-a";
import {
  luxuryPoolBAddress,
  useLuxuryPoolBGetUserInfo,
  useLuxuryPoolBWithdraw,
  usePrepareLuxuryPoolBWithdraw,
} from "@quint/services/web3/hooks/luxury-pool-b";
import { parseError } from "@quint/services/web3/utils/parse-error";
import { useToast } from "@quint/ui/toast";
import MonkeyImage from "public/images/luxury/monkey.png";
import RaffleImage from "public/images/luxury/raffle.png";
import MysteryImage from "public/images/luxury/mystery.jpg";
import { useCallback } from "react";
import { useAccount, useWaitForTransaction } from "wagmi";

const PoolAWithdrawButton = () => {
  const { enqueueToast } = useToast();
  const { config, error, isLoading: isPreparing } = usePrepareLuxuryPoolAWithdraw({});

  const { write, data, isLoading: isWriting } = useLuxuryPoolAWithdraw(config);
  const WithdrawValues = useCallback(() => {
    if (error) {
      enqueueToast({
        title: "Failed To Harvest",
        message: parseError(error),
        variant: "error",
      });
      return;
    }
    if (!write) {
      enqueueToast({
        title: "Preparing...",
        message: "Please wait we are preparing your data",
        variant: "error",
      });
      return;
    }
    write?.();
  }, [enqueueToast, error, write]);

  const { isLoading: isWaiting } = useWaitForTransaction({
    hash: data?.hash,
    onSuccess: () => {
      enqueueToast({
        title: "Harvest Success",
        message: "Successfully harvested your tokens",
        variant: "success",
      });
    },
    onError: (err) => {
      enqueueToast({
        title: "Failed To Harvest",
        message: parseError(err),
        variant: "error",
      });
    },
  });
  const isLoading = isPreparing || isWriting || isWaiting;
  return <Award.WithdrawButton onClick={WithdrawValues} loading={isLoading} />;
};
const PoolBWithdrawButton = () => {
  const { enqueueToast } = useToast();
  const { config, error, isLoading: isPreparing } = usePrepareLuxuryPoolBWithdraw();

  const { write, data, isLoading: isWriting } = useLuxuryPoolBWithdraw(config);
  const WithdrawValues = useCallback(() => {
    if (error) {
      enqueueToast({
        title: "Failed To Harvest",
        message: parseError(error),
        variant: "error",
      });
      return;
    }
    if (!write) {
      enqueueToast({
        title: "Preparing...",
        message: "Please wait we are preparing your data",
        variant: "error",
      });
      return;
    }
    write?.();
  }, [enqueueToast, error, write]);

  const { isLoading: isWaiting } = useWaitForTransaction({
    hash: data?.hash,
    onSuccess: () => {
      enqueueToast({
        title: "Harvest Success",
        message: "Successfully harvested your tokens",
        variant: "success",
      });
    },
    onError: (err) => {
      enqueueToast({
        title: "Failed To Harvest",
        message: parseError(err),
        variant: "error",
      });
    },
  });
  const isLoading = isPreparing || isWriting || isWaiting;
  return <Award.WithdrawButton onClick={WithdrawValues} loading={isLoading} />;
};

const PoolAStakedValues = () => {
  const { address } = useAccount();
  const { data, isLoading } = useLuxuryPoolAGetUserInfo({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    args: [address!],
    enabled: Boolean(address),
  });
  return <Money value={formatBigNumber(data?._totalDeposit)} isLoading={isLoading} />;
};
const PoolBStakedValues = () => {
  const { address } = useAccount();
  const { data, isLoading } = useLuxuryPoolBGetUserInfo({
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    args: [address!],
    enabled: Boolean(address),
  });
  return <Money value={formatBigNumber(data?._totalDeposit)} isLoading={isLoading} />;
};
const awards: AwardCardProps[] = [
  {
    drawDate: "-",
    imageSrc: MysteryImage,
    imageAlt: "Mystery Image",
    poolName: "Pool C",
    stakedAmount: <>-</>,
    status: "comingSoon",
    name: "Mystery",
    withdrawButton: <Award.WithdrawButton disabled />,
    address: "0x",
    winningWallets: ["-"],
  },
  {
    drawDate: "18TH OCTOBER 2022",
    imageSrc: MonkeyImage,
    imageAlt: "BORED APE YACHT CLUB #575",
    poolName: "Pool B",
    stakedAmount: <PoolBStakedValues />,
    status: "done",
    name: "BORED APE YACHT CLUB #575",

    winningWallets: ["0x64619f611248256F7F4b72fE83872F89d5d60d64"],
    address: luxuryPoolBAddress,
    withdrawButton: <PoolBWithdrawButton />,
  },
  {
    drawDate: "08TH JULY 2022",
    imageSrc: RaffleImage,
    imageAlt: "2 HUBLOT BIG BANG INTEGRAL PAVE WATCHES",
    poolName: "Pool A",
    stakedAmount: <PoolAStakedValues />,
    status: "done",
    name: "2 HUBLOT BIG BANG INTEGRAL PAVE WATCHES",

    winningWallets: ["0x64619f611248256F7F4b72fE83872F89d5d60d64", "0x64619f611248256F7F4b72fE83872F89d5d60d62"],
    address: luxuryPoolAAddress,
    withdrawButton: <PoolAWithdrawButton />,
  },
];

export const Awards = () => {
  return (
    <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">
      {awards.map((award) => {
        return <Award.Card key={award.name} {...award} />;
      })}
    </div>
  );
};
